import EmailIcon from "assets/icons/medium/email.svg?react";
import PencilIcon from "assets/icons/medium/pencil.svg?react";
import SettingIcon from "assets/icons/medium/settings.svg?react";
import {
  LeftNavigationMenu,
  type MenuItem,
} from "components/left-navigation-menu/components/left-navigation-menu";
import { AGENCY_SETTINGS_PATHS } from "modules/agency-settings/paths";

const menuItems: MenuItem[] = [
  {
    label: "Branding",
    path: AGENCY_SETTINGS_PATHS.BRANDING,
    Icon: PencilIcon,
  },
  {
    label: "Feature preferences",
    path: AGENCY_SETTINGS_PATHS.FEATURE_PREFERENCES,
    Icon: SettingIcon,
  },
  {
    label: "Rex Hub Login Email",
    path: AGENCY_SETTINGS_PATHS.VENDOR_EMAIL,
    Icon: EmailIcon,
  },
];

export function AgencySettingsNavigationMenu() {
  return (
    <LeftNavigationMenu
      items={menuItems}
      hideAgencyContacts
      hideListingSelector
    />
  );
}
